"use strict";
import "src/decidim/admin/proposal_infinite_edit";
import BudgetRuleTogglerComponent from "src/decidim/admin/budget_rule_toggler.component";
document.addEventListener("turbo:load", () => {
  const budgetTogglerRadios = Array.from(
    document.querySelectorAll(
      "input[type='radio'][name='component[settings][voting_rule]']"
    )
  );
  const budgetTogglerMapping = {
    thresholdPercent: [".vote_threshold_percent_container"],
    minimumProjects: [".vote_minimum_budget_projects_number_container"],
    selectedProjects: [
      ".vote_selected_projects_minimum_container",
      ".vote_selected_projects_maximum_container"
    ]
  };
  const budgetToggler = new BudgetRuleTogglerComponent({
    ruleRadios: budgetTogglerRadios,
    mapping: budgetTogglerMapping
  });
  budgetToggler.init();
  const $readonlyContainer = $(".readonly_container input");
  $readonlyContainer.click((event) => {
    event.preventDefault();
    return false;
  });
  const $amendmentsEnabled = $("input#component_settings_amendments_enabled");
  if ($amendmentsEnabled.length > 0) {
    const $amendmentStepSettings = $(".amendments_wizard_help_text_container, .amendments_visibility_container, .amendment_creation_enabled_container, .amendment_reaction_enabled_container, .amendment_promotion_enabled_container");
    if ($amendmentsEnabled.is(":not(:checked)")) {
      $amendmentStepSettings.hide();
    }
    $amendmentsEnabled.click(() => {
      $amendmentStepSettings.toggle();
    });
  }
  const $attachmentsAllowedCheckbox = $("#component_settings_attachments_allowed");
  const $attachmentsHelpText = $(".attachments_allowed_container .help-text");
  if (!$attachmentsAllowedCheckbox.is(":checked")) {
    $attachmentsHelpText.hide();
  }
  $attachmentsAllowedCheckbox.on("change", () => {
    if ($attachmentsAllowedCheckbox.is(":checked")) {
      $attachmentsHelpText.show();
    } else {
      $attachmentsHelpText.hide();
    }
  });
});
